import React from "react";
import Skeleton from "react-loading-skeleton";

const PlaceholderCard = ({ count = 1, statsskelton, circle, ...rest }) => {
  return (
    <>
      <div className="sim-list for-load">
        {Array.from({ length: count }).map((_, index) => (
          <div className="group-user-card" key={index}>
            <div className="group-card w-100 px-3">
              <div className="group-avatar">
                <Skeleton
                  circle={circle}
                  width={rest.width || 80}
                  height={rest.height || 80}
                  style={{ margin: "0 auto", display: "block" }}
                />
              </div>
              <h6 className="group-name w-100 text-center">
                <Skeleton width="50%" height="1rem" />
              </h6>
              <div className="group-details w-100 text-center" style={{ display: "block" }}>
                <Skeleton width="90%" height="0.85rem" />
              </div>
              {statsskelton && (
                <div className="stats w-100">
                  <span className="item d-block w-100">
                    <Skeleton style={{ width: "100%", height: "2rem" }} />
                  </span>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default PlaceholderCard;
